// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/rem.css';

Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/css/style.css';
import './assets/css/change.css';
import storage from './util/storage.js' //存储
import axios from 'axios';
import qs from 'qs';
import Global from './util/global';
// import formatDate from './util/time.js'
Vue.config.ignoredElements = ['wx-open-launch-weapp', "wx-open-subscribe"];
// import WechatPlugin from './util/WechatPlugin'
// // 全局注册微信jsdk
// Vue.use(WechatPlugin)
Vue.prototype.$storage = storage;

axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.GLOBAL = Global;

Vue.use(Vant);
import versionTood from './util/versionUpdate' //版本号
router.beforeEach((to, from, next) => {
    //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
    versionTood.isNewVersion();
    let url = window.location.href;
    if (url.includes('?from=')) { // 判断是否携带了 from 参数，这一步灵活变通，只要能判断出是从微信分享链接进来的就 OK
        url = url.replace(/vip.+.#/, 'vip/#'); // 利用正则表达式去掉微信携带的 ?from=singlemessage&isappinstalled=0 这串参数，如果这串参数对于你当前的页面有用处的话，可以重新拼接到你正常的链接后面去
        window.location.href = url; // 重定向到正常链接
    }
    // console.log("生命周期 - 挂载完成222", url, url.includes('?from='));
    var time = new Date().getTime(); // 当前时间
    var expires_in = storage.get("expires_in"); // 过期时间
    // 当前时间 大于 过期时间  重新获取token
    // console.log('当前时间' + time);
    // console.log('路由守卫', to, to.query.is_zc)
    if (time > expires_in) {
        getToken();
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    storage.set("zcObj3", null); //将旧缓存清空
    var zcObj = storage.get("zcObj4");
    var detailUrl = window.location.href.split("index.html#")[0];
    var openMath = storage.get("openMath"); //获取缓存的唯一码
    console.log('缓存唯一码', openMath, '链接返回有唯一码', to.query.math_time, to.query, detailUrl);
    if (to.query.math_time) { //链接返回有唯一码

        let math_time = to.query.math_time
            // 随机码被篡改或与缓存不一致会重新请求openID，造成参数重复返回来的为数组
            // 若返回随机码为数组，则取最后一个
        if (typeof math_time == 'object') {
            math_time = math_time[math_time.length - 1]
        }
        // 缓存唯一码与链接返回唯一码一致&存在openID
        if (math_time == openMath && to.query.is_zc) {
            let is_zcA = to.query.is_zc
            if (typeof is_zcA == 'object') {
                is_zcA = is_zcA[is_zcA.length - 1]
            }
            let openidA = to.query.openid
            if (typeof openidA == 'object') {
                openidA = openidA[openidA.length - 1]
            }
            let nicknameA = to.query.nickname
            if (typeof nicknameA == 'object') {
                nicknameA = nicknameA[nicknameA.length - 1]
            }
            let obj = {
                is_zc: is_zcA,
                openid: openidA,
                nickname: nicknameA,
            };

            storage.set("zcObj4", obj); //缓存openID
            storage.set("openMath", ''); //清空唯一码
            zcObj = obj
        }
    }
    let vueVersion = localStorage.getItem('vueVersion')
    console.log("缓存zcObj", zcObj, vueVersion);
    // 没有获取到缓存的openID时去获取openID
    if ((zcObj == null || zcObj == '' || zcObj == undefined) && vueVersion != null) {
        let math = new Date().getTime()
        storage.set("openMath", math); //缓存唯一码
        // var getNum = storage.get("getNum") || 0; //请求的次数
        // getNum = getNum * 1 + 1
        // if (getNum > 3) {
        //     return false
        // }
        // storage.set("getNum", getNum * 1 + 1);
        // window.location.href = "https://dongcheng.net-tactic.com/member/registerWechat?return_url=" +
        //     encodeURIComponent(detailUrl) + '&math_time=' + math;
        window.location.href = "http://www.dci-hotel.com/member/registerWechat?return_url=" +
            encodeURIComponent(detailUrl) + '&math_time=' + math;
    }
    next()
});



// token失效重新请求
function getToken() {
    var data = { email: "test123@qq.com", password: "123456" };
    axios
        .post(
            // "http://hotelapi.net-tactic.com/api/v1/login",
            Global.host + "api/v1/login",
            // "http://dongcheng.net-tactic.com/api/v1/login",
            // "http://192.168.0.107/api/v1/login",

            qs.stringify(data)
        )
        .then(res => {
            // console.log(res); //请求成功返回的数据
            var time = new Date().getTime();
            var expires_in = time * 1 + 3200000; //1740000;
            if (res.data.access_token != "") {
                storage.set('token', res.data.access_token);
                storage.set("expires_in", expires_in);
            }

            // "hsqnm8g8xENT"  君璞  "15ugl5dgkkRRUw" 东城  hsrylsE2lUVRXQ(东城测试)   h8unyck8wkVR：春沐源
        });
}
storage.set('token', '123456');
storage.set('business_id', "15ugl5dgkkRRUw");
// storage.set('business_id', "hs6gnMA9kEJWUA"); //测试
// storage.set('business_id', "hsrylsE2lUVRXQ"); //测
storage.set('hotel_id', "2"); //酒店id
storage.set('channel', "OTA"); //	渠道码
storage.set('cardno', "K000031"); //会员卡号


Date.prototype.toLocaleString = function(formate) {
    if (formate == 'YYYY-MM-DD') {
        return this.getFullYear() + "-" + getMath(this.getMonth() + 1) + "-" + getMath(this.getDate())
    }
    // console.log('toLocaleString', getMath(this.getMonth() + 1), getMath(this.getDate()))
    return this.getFullYear() + "-" + getMath(this.getMonth() + 1) + "-" + getMath(this.getDate()) + "  " + getMath(this.getHours()) + ":" + getMath(this.getMinutes()) + ":" + getMath(this.getSeconds());
};

function getMath(num) {
    if (num * 1 < 10) {
        return num = '0' + num
    } else {
        return num
    }
}
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js